import { useLangContext } from "../../../../providers/LangProvider/LangProviderContext";
import { PUBLIC_URL } from "../../../../config";
import { PromocodeHelloJetvixImgWrapperStyled, } from "./styled/BonusDoubleDepositStyled";
import { Button } from "react-bootstrap";
import BinIcon from "../../../../components/icon/Icon";
import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { getBonusPromocode } from "../../bonusesSelectors";
import { setBonusPromocodeAction } from "../../bonusesActions";
import { PROMOCODE_NAMES } from "../../bonusesConstants";

interface IPromocodeHelloJetvixProps {
    onTopUpClick: () => void;
}

function PromocodeHelloJetvix(props: IPromocodeHelloJetvixProps) {
    const { onTopUpClick } = props;
    const selectedPromocode = useSelector(getBonusPromocode);
    const dispatch = useDispatch();

    const { getLangPath } = useLangContext();

    useEffect(() => {
        return () => {
            dispatch(setBonusPromocodeAction(PROMOCODE_NAMES.HELLOJETVIX));
        }
    }, [dispatch, selectedPromocode]);

    return <div className={'d-flex flex-column'}>
        <PromocodeHelloJetvixImgWrapperStyled>
            <img src={`${PUBLIC_URL}/assets/bonus/bonus-double.png`} alt={'bonus-double'}/>
        </PromocodeHelloJetvixImgWrapperStyled>

        <h2 className={'text-center my-3'}>{getLangPath('bonuses.x_two_your_bonus')}</h2>

        <span className={'text-center f16'}>{getLangPath('bonuses.top_up_and_boost_balance')}</span>

        <Button onClick={onTopUpClick} className={'mt-4'}>
            <div className={'d-flex align-items-center justify-content-center'}>
                <BinIcon name={'IcPlusCircle'}/>
                <span className={'ms-1'}>{getLangPath('deposit.button_now')}</span>
            </div>
        </Button>
    </div>
}

export default PromocodeHelloJetvix;
